<template>
  <div class="home container1">
    <p>Restart vašeho hesla pro účet ve službě ARTHUR.</p><br>
    <div class="text-left">Zadejte váš email</div>
       <div class="d-flex kontak">
        <input type="text" class="in1" v-model="email">
        <button class="btn" @click.prevent="pozadat">Odeslat email</button>
      </div>

    <p v-if="poslan">Zkontrolujte svůj email a klikněte na link pro restart vašeho hesla.</p>

    <p class="alert" v-if="err">{{err}}</p>

  </div>
</template>

<script>
// @ is an alias to /src
const axios = require('axios')
export default {
  name: 'RestartReq',
  components: {

  },
  data () {
    return {
      show1: false,
      err:'',
      email: '',
      poslan:false,
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  methods: {
    pozadat () {
      axios.post( '/api/v2/users/reset_password', { email: this.email }, { headers: { 'Access-Control-Allow-Origin': '*' } } ).then(result => {
        console.log('res', result.data)
        // eslint-disable-next-line eqeqeq
        if (result.status === 202) {
          //console.log('re', result.data)
          this.poslan = true
        }
      }).catch(err => {
        if (err.response.status==404){
          this.err =  err.response.data.error
        }
        //console.error('eee 3', err.response.data)
        if (err.response.status>404){
          this.err = `chyba ${err.response.status}`
        }
      })
    }
  }
}

</script>

<style>
  .kontak{
    margin:1em 0 1em 0;
  }
 input.in1{
    width:70%;
    display: block;
    border-radius:3px;
    border:1px solid black;
    line-height:40px;
    padding:  0 10px 0 10px;
  }

   button.btn{
    border:1px solid black;
    background: white;
    margin-left:10px;
    border-radius:3px;
    line-height:40px;
    padding:  0 10px 0 10px;
  }

  button:hover{
    background: #eee;
    cursor: pointer;
  }

  .alert{
    padding: 10px;
    background: rgba(255, 20, 0, 0.1);
    margin: 10px;
    border-radius: 4px;
    border: 1px solid darkred;
    color: darkred;
  }
</style>
